import { currentPageReducer as currentPage } from './currentPage.reducer';
import { customConnectionURLsReducer as customConnectionURLs } from 'Redux/thunks/customConnectionURL.thunks';
import { datasetsReducer as datasets } from './datasets.reducer';
import { internalEntitiesReducer as internalEntities } from './internalPipes.reducer';
import { liveUpdatesReducer as liveUpdates } from './liveUpdates.reducer';
import { postEntitiesModalReducer as postEntitiesModal } from 'Redux/thunks/postEntitiesModal.thunks';
import { routerReducer as routing } from 'react-router-redux';
import { subscriptionReducer as subscription } from './datahub.reducer';
import { downstreamsReducer as downstreams } from './downstreams.reducer';
import { editorReducer as editor } from './editor.reducer';
import { envReducer as env } from './env.reducer';
import { globalsReducer as globals } from './globals.reducer';
import { inboundsReducer as inbounds } from './inbounds.reducer';
import { jwtReducer as jwt } from './jwt.reducer';
import { loadStatusReducer as loadStatus } from './loadStatus.reducer';
import { lookupsReducer as lookups } from './lookups.reducer';
import { modelsReducer as models } from './models.reducer';
import { navigationReducer as navigation } from './navigation.reducer';
import { outboundsReducer as outbounds } from './outbounds.reducer';
import { paymentMethodsReducer as paymentMethods } from './paymentMethods.reducer';
import { pipesReducer as pipes } from './pipes.reducer';
import { secretsReducer as secrets } from './secrets.reducer';
import { simpleSettingsReducer as simpleSettings } from './simpleSettings.reducer';
import { subscriptionsReducer as subscriptions } from './subscriptions.reducer';
import { systemsReducer as systems } from './systems.reducer';
import { themeReducer as theme } from './theme.reducer';
import { toastsReducer as toasts } from './toasts.reducer';
import { transformsReducer as transforms } from './transforms.reducer';
import { upstreamsReducer as upstreams } from './upstreams.reducer';
import { userReducer as user } from './user.reducer';
import { zendeskReducer as zendesk } from './zendesk.reducer';

export const RootReducer = {
  subscription,
  subscriptions,
  pipes,
  systems,
  datasets,
  liveUpdates,
  internalEntities,
  upstreams,
  downstreams,
  inbounds,
  outbounds,
  models,
  transforms,
  jwt,
  customConnectionURLs,
  loadStatus,
  paymentMethods,
  secrets,
  simpleSettings,
  toasts,
  user,
  postEntitiesModal,
  lookups,
  editor,
  env,
  globals,
  routing,
  navigation,
  currentPage,
  theme,
  zendesk,
};
